import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import _ from 'underscore';
import { SelectionTreeContext } from '../context';

import { buildMap } from '../utils';
import { DataSourceProps } from '../types';

export const ServerDataSource: React.FC<DataSourceProps> = ({ fetchData }) => {
  const [allItems, setAllItems] = useState([]);
  const {
    searchQuery,
    updateItemsMap,
    updateItems,
    updateIsLoading,
  } = useContext(SelectionTreeContext);
  const fetchNewData = useMemo(() => _.debounce(() => fetchData({ searchQuery }).then((data) => {
    updateIsLoading(false);
    updateItems(data);

    const newItems = data.filter((item) => !allItems.some((x) => x.value === item.value));
    if (newItems.length !== 0) {
      setAllItems([...allItems, ...newItems]);
    }
  }), 200), [fetchData, searchQuery, updateItems, updateIsLoading]);

  useEffect(() => {
    const newItemsMap = buildMap(allItems);
    updateItemsMap(newItemsMap);
  }, [allItems]);

  useEffect(() => {
    updateIsLoading(true);
    fetchNewData();
  }, [fetchNewData, searchQuery, updateIsLoading]);

  return null;
};
